import { IAttendance, IAttendanceById, IAttendanceData, IAttendanceParams, ITableRes } from 'types'

import { baseApi } from './baseApi'

export const attendanceAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_attendance: builder.query<ITableRes<IAttendance>, IAttendanceParams>({
      query: (params) => ({
        url: '/attendance/',
        params,
      }),
      providesTags: ['attendance'],
    }),
    GET_attendanceById: builder.query<ITableRes<IAttendanceById>, string>({
      query: (id) => ({
        url: `/attendance/${id}/`,
      }),
      providesTags: ['attendance'],
    }),
    POST_attendance: builder.mutation<IAttendanceById, IAttendanceData>({
      query: (body) => ({
        url: `/attendance/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['attendance'],
    }),
    PATCH_attendance: builder.mutation<IAttendanceById, { id: string; body: IAttendanceData }>({
      query: ({ id, body }) => ({
        url: `/attendance/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['attendance'],
    }),
    DELETE_attendance: builder.mutation<IAttendanceById, string>({
      query: (id) => ({
        url: `/attendance/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['attendance'],
    }),
  }),
})

export const {
  useGET_attendanceQuery,
  useGET_attendanceByIdQuery,
  usePOST_attendanceMutation,
  usePATCH_attendanceMutation,
  useDELETE_attendanceMutation,
} = attendanceAPI
